<main id="main-content" tabindex="-1" aria-label="Reports">
  <div class="max-h-fit py-10">
    <div class="grid grid-cols-2">
      <div class="col-span-2 lg:col-span-1 items-center pb-4">
        <prism-title title="Reports" additionalClasses="text-3xl md:pl-20"></prism-title>
      </div>
    </div>

    <!-- Summary cards: driven by the same filter state as the grid below -->
    <div class="grid grid-cols-2">
      <div class="col-span-2 xl:lg:col-span-1">
        <prism-report-card
          [graph]="graphType.line"
          [reportCardData]="districtCardData"
          [isLoading]="isDistrictLoading">
        </prism-report-card>
      </div>
      <div class="col-span-2 xl:lg:col-span-1">
        <prism-report-card
          [graph]="graphType.doughnut"
          [reportCardData]="completionsCardData"
          [isLoading]="isCompletionsLoading">
        </prism-report-card>
      </div>
    </div>

    <div class="pl-4 sm:pl-6 md:pl-8 lg:pl-10 pr-2 sm:pr-4">
      <prism-report-filters
        [form]="filterForm"
        [completionStatusOptions]="completionStatusOptions"
        (search)="onSearch()">
      </prism-report-filters>

      <prism-report-results [filters]="filters"></prism-report-results>
    </div>
  </div>
</main>
